import { createContext, useContext } from "react";

export interface DialogDataContainer {
    show: boolean;
    element: JSX.Element;
    key: string;
    onClose?: (result?: any) => void;
    backDropClose: boolean;
    style?: React.CSSProperties;
}

export interface DialogContextType {
    dialogs: DialogDataContainer[];
    openDialog: (
        element: JSX.Element,
        onClose?: (result?: any) => void,
        backDropClose?: boolean,
        style?: React.CSSProperties
    ) => void;
    closeDialog: (result?: any) => void;
}

const initialValue: DialogContextType = {
    dialogs: [],
    openDialog: (
        _element: JSX.Element,
        _onClose?: (result?: any) => void,
        _backDropClose?: boolean,
        _style?: React.CSSProperties
    ) => {},
    closeDialog: (_result?: any) => {},
};

export const DialogContext = createContext(initialValue);

export const useDialogContext = () => {
    return useContext(DialogContext);
};
